module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('van-dialog', {
    attrs: {
      "showConfirmButton": _vm.showConfirmButton,
      "closeOnClickOverlay": _vm.closeOnClickOverlay
    },
    on: {
      "close": _vm.onClose
    },
    model: {
      value: (_vm.bookShow),
      callback: function($$v) {
        _vm.bookShow = $$v
      },
      expression: "bookShow"
    }
  }, [_c('div', {
    staticClass: "wxdialog"
  }, [_c('img', {
    attrs: {
      "src": _vm.wxPic
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wxcode"
  }, [_vm._v("客服微信：" + _vm._s(_vm.wxCode))]), _vm._v(" "), _c('div', {
    staticClass: "wxNote"
  }, [_vm._v(_vm._s(_vm.wxNote))]), _vm._v(" "), _c('div', {
    staticClass: "wxNote"
  }, [_vm._v("\n            " + _vm._s(_vm.phone) + "\n            "), _c('van-button', {
    attrs: {
      "type": "info",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.openPhone(_vm.phone)
      }
    }
  }, [_vm._v("拨打电话")])], 1), _vm._v(" "), _c('van-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.wxCode),
      expression: "wxCode",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }],
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("点击复制或长按图片识别，添加好友")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5ee8212","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BookDialog.vue
// module id = 2559
// module chunks = 0